import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class KuposDataNotFound extends Component {
  static propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    infoTexts: PropTypes.string,
    onInfoClick: PropTypes.func,
  };

  render() {
    return (
      <div className="common-kupos-data-not-found font11 center-text">
        <div className="icon">
          <img src={this.props.icon} />
        </div>
        <div className="title bold-text">{this.props.title}</div>
        <div className="sub-title">{this.props.subTitle}</div>
        <div className={'info-text-container font10 ' + (this.props.onInfoClick ? 'pointer' : '')}>
          <style>
            .common-kupos-data-not-found .info-text:before
            {'{'}
            content: ""; display: block; width: 0; height: 0; border-left: 5px solid transparent;
            border-right: 5px solid transparent; top: -12px; left: 20%; position: absolute;
            border-bottom: 13px solid{' '}
            {this.props.operator &&
            this.props.operator.color_codes &&
            this.props.operator.color_codes.accounts_bg_color
              ? this.props.operator.color_codes.accounts_bg_color
              : ''}
            ; ;
          </style>
          <div
            className="info-text"
            style={{
              background:
                this.props.operator &&
                this.props.operator.color_codes &&
                this.props.operator.color_codes.accounts_bg_color
                  ? this.props.operator.color_codes.accounts_bg_color
                  : '',
            }}
            onClick={this.props.onInfoClick ? this.props.onInfoClick : null}
          >
            {this.props.infoText}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/KuposDataNotFound.js